module.exports = __webpack_public_path__ + "img/linked-in-info.64d5ac3b.webp";